// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__pGkP4","author":"Table_author__3mt8w","authorImage":"Table_authorImage__2GLiQ","unreadRow":"Table_unreadRow__1XRCY"};